import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const WorkOrderApprovedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SUNRUN_WORK_ORDER_APPROVED),
  projectId: z.number(),
  reason: z.enum(["WO_REJECTED_FINDINGS", "WO_REJECTED_INVOICE", "WO_REJECTED_OTHER"]),
});

export type WorkOrderApprovedTaskAttempt = z.infer<typeof WorkOrderApprovedTaskAttemptSchema>;
